import React from 'react'
import { Icon } from 'gu-ui-kit'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import renderInputField from 'components/FormControls/textInput'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'

export const Account = ({
  className = '',
  method = '',
  t = () => {},
  params: { is_available = null, account = null, is_expired = false } = {},
}) => {
  const pathGen = useGeneratePathI18n()

  return is_available === null ? null : (
    <div className={className}>
      <Field
        name="account"
        fullWidth
        readOnly
        label={
          account && is_available === true && !is_expired
            ? t('account_balance', {
                account: account.username || account.login,
                method: t(`methods.${method}`),
              })
            : t('account', {
                account: t(`methods.${method}`),
              })
        }
        InputProps={{
          endAdornment:
            account === null ? (
              <a
                className={styles['billing__profile-button']}
                href={pathGen(ROUTES.USER_SETTINGS)}
              >
                <Icon
                  name={'plus'}
                  size={'s'}
                  color={'Interface-Seventh'}
                  className={styles['filter-button__icon']}
                />
                &nbsp;{t('connect')}
              </a>
            ) : null,
        }}
        helperText={
          !account || is_available === false || is_expired === true ? (
            <span
              dangerouslySetInnerHTML={{
                __html: t('connect_account', {
                  link: pathGen(ROUTES.USER_SETTINGS),
                }),
              }}
            />
          ) : null
        }
        t={t}
        component={renderInputField}
      />
    </div>
  )
}

Account.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  method: PropTypes.string,
  t: PropTypes.func,
  params: PropTypes.object,
}
